import { render, staticRenderFns } from "./need-details.vue?vue&type=template&id=85b3517e&scoped=true&"
import script from "./need-details.vue?vue&type=script&lang=js&"
export * from "./need-details.vue?vue&type=script&lang=js&"
import style0 from "./need-details.vue?vue&type=style&index=0&id=85b3517e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b3517e",
  null
  
)

export default component.exports